export default "__VITE_ASSET__C3w4OwJo__"